import React, { useState, useEffect } from 'react';
import { Select, Space, Tag } from 'antd';
import { getChannelLogo } from '../utils/channelLogos';
import { useLanguage } from '../contexts/LanguageContext';

const ChannelPermissionSelector = ({ value = {}, onChange }) => {
  const { t } = useLanguage();
  const [allChannelConfigs, setAllChannelConfigs] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState(value.channel || null);
  const [selectedCurrencies, setSelectedCurrencies] = useState(value.currencies || []);

  useEffect(() => {
    loadAllChannelConfigs();
  }, []);

  const loadAllChannelConfigs = async () => {
    try {
      console.log('Loading channel configs...');
      const response = await fetch('/inner/v1/fiat-payment/test/execute', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          testType: 'CHANNEL_CONFIGS_LIST',
          executor: 'system'
        })
      });
      const result = await response.json();
      console.log('Channel configs response:', result);
      if ((result.code === '200' || result.code === 200) && result.data) {
        const configs = Array.isArray(result.data) ? result.data
          : Array.isArray(result.data.responseBody) ? result.data.responseBody
          : [];
        console.log('Setting channel configs:', configs);
        setAllChannelConfigs(configs);
      } else {
        console.log('Using fallback mock data');
        // 使用模拟数据作为备选
        const mockData = [
          { channelCode: 'KORAPAY', currency: 'NGN' },
          { channelCode: 'KORAPAY', currency: 'KES' },
          { channelCode: 'PAGSMILE', currency: 'BRL' },
          { channelCode: 'PAGSMILE', currency: 'MXN' },
          { channelCode: 'PYVIO', currency: 'USD' },
          { channelCode: 'PYVIO', currency: 'EUR' }
        ];
        setAllChannelConfigs(mockData);
      }
    } catch (error) {
      console.error('Failed to load channel configs:', error);
      // 使用模拟数据作为备选
      const mockData = [
        { channelCode: 'KORAPAY', currency: 'NGN' },
        { channelCode: 'KORAPAY', currency: 'KES' },
        { channelCode: 'PAGSMILE', currency: 'BRL' },
        { channelCode: 'PAGSMILE', currency: 'MXN' },
        { channelCode: 'PYVIO', currency: 'USD' },
        { channelCode: 'PYVIO', currency: 'EUR' }
      ];
      setAllChannelConfigs(mockData);
    }
  };

  const availableChannels = [...new Set(allChannelConfigs.map(c => c.channelCode))].filter(Boolean);
  console.log('Available channels:', availableChannels);
  const availableCurrencies = selectedChannel 
    ? [...new Set(allChannelConfigs.filter(c => c.channelCode === selectedChannel).map(c => c.currency))].filter(Boolean)
    : [];

  const handleChannelChange = (channel) => {
    setSelectedChannel(channel);
    setSelectedCurrencies([]);
    onChange?.({ channel, currencies: [] });
  };

  const handleCurrencyChange = (currencies) => {
    setSelectedCurrencies(currencies);
    onChange?.({ channel: selectedChannel, currencies });
  };

  return (
    <div style={{ 
      background: '#f8fafc', 
      padding: '20px', 
      borderRadius: '12px', 
      border: '1px solid #e2e8f0' 
    }}>
      <div style={{ marginBottom: 20 }}>
        <div style={{ 
          marginBottom: 12, 
          fontWeight: 600, 
          fontSize: 16,
          color: '#1e293b',
          display: 'flex',
          alignItems: 'center'
        }}>
          <span style={{ marginRight: 8 }}>📊</span>
          {t('channel')}：
        </div>
        <Select
          placeholder={t('selectChannel')}
          value={selectedChannel}
          onChange={handleChannelChange}
          style={{ width: '100%' }}
          size="large"
          options={availableChannels.map(c => {
            const logo = getChannelLogo(c);
            return {
              label: (
                <Space>
                  <span style={{ fontSize: 16 }}>{logo.emoji}</span>
                  <span style={{ fontWeight: 500 }}>{logo.name}</span>
                </Space>
              ),
              value: c
            };
          })}
        />
      </div>
      
      {selectedChannel && (
        <div>
          <div style={{ 
            marginBottom: 12, 
            fontWeight: 600, 
            fontSize: 16,
            color: '#1e293b',
            display: 'flex',
            alignItems: 'center'
          }}>
            <span style={{ marginRight: 8 }}>💰</span>
            {t('currency')}：
          </div>
          <Select
            mode="multiple"
            placeholder={t('selectCurrency')}
            value={selectedCurrencies}
            onChange={handleCurrencyChange}
            style={{ width: '100%' }}
            size="large"
          >
            {availableCurrencies.map(currency => (
              <Select.Option key={currency} value={currency}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Tag color="orange" style={{ margin: 0, borderRadius: 6 }}>{currency}</Tag>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>
      )}
    </div>
  );
};

export default ChannelPermissionSelector;